export default {
  BusinessPurchaseComponentsPur: {
    time: '最新同步时间',
    title: '采购单基本信息',
    code: '采购单号',
    automatic: '自动生成',
    supplierCode: '供应商',
    type: '采购类型',
    buyerName: '采购员',
    warehouseCode: '收货仓库',
    paymentType: '结算方式',
    expectedDate: '预计到货时间',
    overfillRate: '溢装比例',
    invoiceType: '发票类型',
    packagingFlag: '是否含包装',
    shippingFlag: '是否包邮',
    logisticsAmount: '运费',
    logisticsBusinessId: '物流公司',
    logisticsNo: '物流单号',
    recipientName: '收货人',
    recipientPhone: '收货手机',
    recipientAddress: '收件地址',
    detailAddress: '详细地址',
    remark: '备注',
    information: '商品信息',
    addingGoods: '添加商品',
    POStatus: '采购单状态',
    postingDate: '订单创建日期',
    documentDate: '订单生成日期',
    requiredDate: '需求日期',
    vendorRefNo: '供应商参考码',
    getPONo: '同步到货数量',
    fixRecvQty: '修复收货数量',

    table: {
      picture: '商品图片',
      supplierName: '要求供应商',
      waitQty: '未下采购单数量',
      applyCode: '采购申请单号',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      planQty: '下单数量',
      taxUnitPrice: '含税下单价',
      excludingTax: '不含税采购价',
      taxRate: '税率',
      taxPrice: '含税金额',
      supplierSpuCode: '供应商商品编码',
      supplierSkuCode: '供应商SKU编码',
      storageTypeText: '请选择入库类型',
      warehouseCodeText: '请选择收货仓库',
      supplierCodeText: '请选择供应商',
      paymentTypeText: '请选择结算方式',
      expectedDateText: '请选择预计到货时间',
      planQtyText: '请输入单据数量',
      taxUnitPriceText: '请输入含税下单价',
      taxRateText: '请输入税率',
      data: '数据',
      quotedQty: '采购数量',
      UnitPrice: '单价',
      Discount: ' 折扣',
      TaxCode: '税务编码',
      GrosSprice: '折扣后单价',
      Total: '总计',
      Warehouse: '仓库',
      Length: '长',
      Width: '宽',
      Height: '高',
      Volume: '体积',
      VolumeUnit: '体积单位',
      Weight: '重',
      UomCode: 'UoM编码',
      FreightInformation: '运费信息',
      FreightName: '运费名称',
      TaxGroup: '税务编码',
      Tax: '税 %',
      NetAmount: '不含税净值',
      DistribMethod: 'Distrib.Method',
      TotalTaxAmount: '总税值',
      GrossAmount: '总价',
     },

    dialogText: '选择供应商',
    msgError: '请选择入库商品',
    msgBoxText: '超出采购申请数量，是否确定生成采购单',
    msgError2: '商品已存在,请重新选择！',
    msgError3: '请查看导入的SKU是否正确！',
    msgError4: '请填写完整的表格内容！',
    msgError5: '导入的价格项不含价格单位，请更改后在进行导入！',
    ExportPDF: '导出pdf',
    ViewPDFeffect: '查看pdf效果',
    confirmText1: '未入库数量为',
    confirmText2: '本次入库数量为',
    exportHint: '导入列表中存在错误，请去导入校验页面 改正所有错误后导入',
    barcodeTip: '请确认下载sku 标签吗？一旦下载，会收取客户的费用。'
  }
};
